import { useTranslation } from 'react-i18next'
import { ApplicationModal } from '~/state/application/reducer'
import { useModalToggle } from '~/state/application/hooks'
import { StyledEmptyResult, StyledAddTokenButton } from '../styled'
import IconNoTokenResult from '~/assets/images/no-token-result.png'

interface Props {
  isSearchByAddress: boolean
}

export const EmptySearchResult: React.FC<Props> = ({ isSearchByAddress }) => {
  const { t } = useTranslation()
  const toggle = useModalToggle(ApplicationModal.LO_ADD_CUSTOM_TOKEN)

  return (
    <StyledEmptyResult>
      <img src={IconNoTokenResult.src} />
      <div>
        <p>{t('no_search_result')}</p>
        <p>
          {t(
            isSearchByAddress
              ? 'lo_no_search_result_desc_2'
              : 'lo_no_search_result_desc_1',
          )}
        </p>
      </div>
      {!isSearchByAddress && (
        <StyledAddTokenButton onClick={toggle}>
          {t('import_token')}
        </StyledAddTokenButton>
      )}
    </StyledEmptyResult>
  )
}

export const EmptySearchResultLite: React.FC<Props> = ({
  isSearchByAddress,
}) => {
  const { t } = useTranslation()

  return (
    <StyledEmptyResult>
      <img src={IconNoTokenResult.src} />
      <div>
        <p>{t('no_search_result')}</p>
        <p>
          {t(
            isSearchByAddress
              ? 'lo_no_search_result_desc_2'
              : 'lo_no_search_result_desc_1',
          )}
        </p>
      </div>
    </StyledEmptyResult>
  )
}

export default EmptySearchResult
